/* globals PLUG */

(function (ProductCard) {

    let U;

    ProductCard.export = function () {
        U = PLUG.import("Utils");

        return Object.freeze({
            initListeners
        });
    };

    function initListeners(card) {
        const addToCartButton = card.querySelector(".plug-product-card__add-to-cart-btn, .plug-product-list-item__add-to-cart-btn");
        const cartNotification = document.querySelector("cart-notification");
        if (addToCartButton && !addToCartButton.classList.contains("is-hidden")) {
            const quantityInput = card.querySelector(".quantity__input");
            addToCartButton.addEventListener("click", (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                const quantity = Number(quantityInput.value);
                const variantId = Number(addToCartButton.dataset.variantId);
                U.setButtonLoadingState(addToCartButton, true);
                cartNotification.setActiveElement(document.activeElement);

                const requestBody = JSON.stringify({
                    quantity: quantity,
                    id: String(variantId),
                    sections: cartNotification.getSectionsToRender().map((section) => section.id),
                    sections_url: window.location.pathname
                });

                U.addItemToCart(requestBody, (cartData, reason) => {
                    U.setButtonLoadingState(addToCartButton, false);
                    if (reason) throw reason;
                    const quantityInputEle = card.querySelector("plug-quantity-input");
                    const invManagement = quantityInputEle.dataset.variantInventoryManagement;
                    const invQuantity = quantityInputEle.dataset.variantInventoryQuantity;
                    if (invManagement && invManagement !== "" && invQuantity < quantity) {
                        const alertModal = document.getElementsByTagName("plug-alert-modal")[0];
                        const fcn = function showNotification() {
                            // Without the delay, the cart notification animation doesn't work.
                            setTimeout(function () {
                                cartNotification.renderContents(JSON.parse(cartData));
                            }, 400);
                        };
                        alertModal.open(fcn);
                    } else {
                        cartNotification.renderContents(JSON.parse(cartData));
                    }
                });
            });
        } else {
            const viewOptionsButton = card.querySelector(".plug-product-card__view-options-btn, .plug-product-list-item__view-options-btn");
            viewOptionsButton.addEventListener("click", () => {
                const parentLink = viewOptionsButton.closest("a");
                parentLink.click();
            });
        }
    }

})(PLUG.ProductCard = Object.create(null));
